var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6641 1H2.66406C1.83564 1 1.16406 1.67157 1.16406 2.5V15.5C1.16406 16.3284 1.83564 17 2.66406 17H19.6641C20.4925 17 21.1641 16.3284 21.1641 15.5V2.5C21.1641 1.67157 20.4925 1 19.6641 1Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16406 2.5C1.16406 2.10218 1.3221 1.72064 1.6034 1.43934C1.88471 1.15804 2.26624 1 2.66406 1H19.6641C20.0619 1 20.4434 1.15804 20.7247 1.43934C21.006 1.72064 21.1641 2.10218 21.1641 2.5V7H1.16406V2.5Z",
    stroke: "#111111",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 4C3.16406 3.44772 3.61178 3 4.16406 3C4.71635 3 5.16406 3.44772 5.16406 4C5.16406 4.55228 4.71635 5 4.16406 5C3.61178 5 3.16406 4.55228 3.16406 4Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 4C6.16406 3.44772 6.61178 3 7.16406 3C7.71635 3 8.16406 3.44772 8.16406 4C8.16406 4.55228 7.71635 5 7.16406 5C6.61178 5 6.16406 4.55228 6.16406 4Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.f01358528baf3967e0665bb47b56b915.svg";
export { ForwardRef as ReactComponent };